import React from "react";
import { Link } from "gatsby";
import LayoutContainer from "./LayoutContainer";
import Logo from "./Logo";
import MenuDrawer from "./MenuDrawer";
import CartDrawer from "./CartDrawer";
import { CartItem } from "../types";

interface NavbarProps {
  cartItems: CartItem[];
  cartOpen: boolean;
  setCartOpen: (open: boolean) => void;
  updateCartItem: (cartItem: CartItem, index: number) => void;
  removeCartItem: (index: number) => void;
}

const navItems = [
  { label: "Coffee", href: "/" },
  { label: "Dog Treats", href: "/dog-treats/" },
  { label: "Silver Wolf Studio", href: "/studio/" },
  { label: "Silver Wolf Swag", href: "/swag/" },
];

const Navbar: React.FC<NavbarProps> = props => {
  return (
    <nav className="fixed w-full top-0 left-0 z-50 bg-white shadow-md h-12 flex items-center sm:h-16">
      <LayoutContainer>
        <div className="flex items-center w-full justify-between">
          <div className="flex items-center">
            <div>
              <Link to="/">
                <div className="w-10 sm:w-14 text-primary-700">
                  <Logo />
                </div>
              </Link>
            </div>
            <ul className="hidden lg:flex items-center ml-4 text-primary-700">
              {navItems.map(({ label, href }) => (
                <li key={label} className="ml-6">
                  <Link to={href} activeClassName="active-link">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="flex items-center">
            <div className="pl-4">
              <CartDrawer {...props} />
            </div>
            <div className="pl-4">
              <MenuDrawer />
            </div>
          </div>
        </div>
      </LayoutContainer>
    </nav>
  );
};

export default Navbar;
